import { clsx } from 'clsx';
import { CSSProperties, FC, Ref, forwardRef } from 'react';
import ArrowDown from './images/arrow-down.svg';
import ArrowLeft from './images/arrow-left.svg';
import ArrowLongDown from './images/arrow-long-down.svg';
import ArrowLongLeft from './images/arrow-long-left.svg';
import ArrowLongRight from './images/arrow-long-right.svg';
import ArrowRightBreadcrumbs from './images/arrow-right-breadcrumbs.svg';
import ArrowRight from './images/arrow-right.svg';
import ArrowVerticalLeft from './images/arrow_vertical_left.svg';
import ArrowVerticalRight from './images/arrow_vertical_right.svg';
import Box from './images/box.svg';
import Burger from './images/burger.svg';
import CartWhite from './images/cart-white.svg';
import Cart from './images/cart.svg';
import Close from './images/close.svg';
import Eye from './images/eye.svg';
import FrFlag from './images/fr.svg';
import Heart from './images/heart.svg';
import Info from './images/info.svg';
import Login from './images/login.svg';
import Manual from './images/manual.svg';
import Minus from './images/minus.svg';
import NlFlag from './images/nl.svg';
import Plus from './images/plus.svg';
import Search from './images/search.svg';
import Smile from './images/smile.svg';
import StarFilled from './images/star-filled.svg';
import Star from './images/star.svg';
import Tick from './images/tick.svg';
import Trust from './images/trust.svg';
import styles from './styles.module.css';

const IconSVGConfig = {
  cart: Cart,
  cartWhite: CartWhite,
  heart: Heart,
  login: Login,
  burger: Burger,
  close: Close,
  arrowRight: ArrowRight,
  arrowRightBreadcrumbs: ArrowRightBreadcrumbs,
  arrowLeft: ArrowLeft,
  arrowDown: ArrowDown,
  arrowLongDown: ArrowLongDown,
  arrowVerticalLeft: ArrowVerticalLeft,
  arrowVerticalRight: ArrowVerticalRight,
  arrowLongLeft: ArrowLongLeft,
  arrowLongRight: ArrowLongRight,
  box: Box,
  manual: Manual,
  minus: Minus,
  plus: Plus,
  info: Info,
  eye: Eye,
  nlFlag: NlFlag,
  frFlag: FrFlag,
  search: Search,
  smile: Smile,
  star: Star,
  starFilled: StarFilled,
  tick: Tick,
  trust: Trust,
};

export type IconSvgType = keyof typeof IconSVGConfig;

export const IconSVG: FC<{
  type: IconSvgType;
  className?: string;
  imgClassName?: string;
  onClick?: () => void;
  style?: CSSProperties;
}> = forwardRef(
  ({ type, className, style, onClick, imgClassName, ...props }, ref) => {
    const file = IconSVGConfig[type];

    return !file ? null : (
      <span
        style={style}
        onClick={onClick}
        className={clsx(styles.root, onClick && styles.pointer, className)}
        ref={ref as Ref<HTMLSpanElement>}
        {...props} // props and ref need for correct work inside tooltip
      >
        <img src={file.src} className={imgClassName} alt={`${type} icon`} />
      </span>
    );
  },
);
